import * as React from 'react';
import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import Link from 'next/link';
import { Card, CardContent, Typography, CardActions } from '@mui/material';
import { get_master_loading } from '../../store/actions/service';

export default function CitiesList({language}) {

  const dispatch = useDispatch();

  const citiesList = useMemo(() => [
    {
      id: 1,
      name: 'Paris',
      slug: "paris"
    },
    {
      id: 2,
      name: 'Marseille',
      slug: 'marseille'
    },
    {
      id: 3,
      name: 'Lyon',
      slug: 'lyon'
    },
    {
      id: 4,
      name: 'Toulouse',
      slug: 'toulouse'
    },
    {
      id: 5,
      name: 'Nice',
      slug: 'nice'
    },
    {
      id: 6,
      name: 'Nantes',
      slug: 'nantes'
    },
    {
      id: 7,
      name: 'Montpellier',
      slug: 'montpellier'
    },
    {
      id: 8,
      name: 'Strasbourg',
      slug: 'strasbourg'
    },
    {
      id: 9,
      name: 'Bordeaux',
      slug: 'bordeaux'
    },
    {
      id: 10,
      name: 'Lille',
      slug: 'lille'
    },
    {
      id: 11,
      name: 'Rennes',
      slug: 'rennes'
    },
    {
      id: 12,
      name: 'Reims',
      slug: 'reims'
    },
    {
      id: 13,
      name: 'Toulon',
      slug: 'toulon'
    },
    {
      id: 14,
      name: 'Saint-Étienne',
      slug: 'saint-étienne'
    },
    {
      id: 15,
      name: 'Le Havre',
      slug: 'le havre'
    },
    {
      id: 16,
      name: 'Grenoble',
      slug: 'grenoble'
    },
    {
      id: 17,
      name: 'Dijon',
      slug: 'dijon'
    },
    {
      id: 18,
      name: 'Angers',
      slug: 'angers'
    },
  ], [])

  return (
    <Card sx={{ minWidth: 275 }} className="cities-list">
      <CardContent>
        <Typography variant="h5" component="div">
          Cities
        </Typography>
      </CardContent>
      <CardActions>
        {
          citiesList.map(city => (
            <Link onClick={() => dispatch(get_master_loading())} href={`${language}/masters/?city=${city.slug}`}>{`${city.id}. ${city.name}`}</Link>
          ))
        }
      </CardActions>
    </Card>
  );
}